import { render, staticRenderFns } from "./otherRkHis.vue?vue&type=template&id=d4b7bc6e&scoped=true"
import script from "./otherRkHis.vue?vue&type=script&lang=js"
export * from "./otherRkHis.vue?vue&type=script&lang=js"
import style0 from "./otherRkHis.vue?vue&type=style&index=0&id=d4b7bc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b7bc6e",
  null
  
)

export default component.exports